import { createContext, useContext, useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";
import { DEFAULT_SETTINGS } from "../lib/content";

const SettingsContext = createContext({ settings: DEFAULT_SETTINGS, refresh: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const refresh = useCallback(
    () =>
      api
        .get("/settings")
        .then((r) => setSettings({ ...DEFAULT_SETTINGS, ...r.data }))
        .catch(() => setSettings(DEFAULT_SETTINGS)),
    [],
  );

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = settings || DEFAULT_SETTINGS;
  return (
    <SettingsContext.Provider value={{ settings: value, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
